import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Billing Cancel Page
 * Displayed when user cancels Stripe Checkout
 */
const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-neutral-900 p-8 rounded-lg border border-neutral-700 shadow-xl text-center">
        <div className="w-20 h-20 bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">Checkout Cancelled</h1>
        
        <p className="text-neutral-400 mb-6">
          Your subscription setup was cancelled. No charges were made.
        </p>

        <div className="bg-neutral-800/50 rounded-lg p-4 mb-6">
          <p className="text-neutral-300 text-sm mb-2">
            <strong>Didn't mean to cancel?</strong>
          </p>
          <p className="text-neutral-400 text-sm">
            You can start your free trial anytime. No credit card charges until your 7-day trial ends.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/signup')}
            className="w-full px-6 py-3 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-lg transition-colors"
          >
            Try Again - Start Free Trial
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full px-6 py-2 border border-neutral-600 hover:border-neutral-500 text-neutral-300 hover:text-white rounded-lg transition-colors"
          >
            Go to Dashboard
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full px-6 py-2 text-neutral-400 hover:text-white transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingCancel;

